import { render, staticRenderFns } from "./GraficosVentasComponent.vue?vue&type=template&id=74f83e07"
import script from "./GraficosVentasComponent.vue?vue&type=script&lang=js"
export * from "./GraficosVentasComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports